import moment from "moment";

const convertUtcToLocal = (dateTime, format = "YYYY-MM-DD HH:mm:ss") => {
    const localTime = moment.utc(dateTime).toDate();
    return moment(localTime).format(format);
};

export default convertUtcToLocal;
